import type { Idioma } from "./IdiomaProvider";

export const TEXTOS_EMISSAO_FISCAL: Record<Idioma, Record<string, string>> = {
  pt: {
    "Emitir documento": "Emitir documento",
    "Documento enviado para emissão.": "Documento enviado para emissão.",
    "Emitir documento fiscal": "Emitir documento fiscal",
    "Selecione uma venda concluída. A NF-e exige cliente com CPF/CNPJ e endereço fiscal completos.": "Selecione uma venda concluída. A NF-e exige cliente com CPF/CNPJ e endereço fiscal completos.",
    "Enviar para emissão": "Enviar para emissão",
    "Emissão fiscal": "Emissão fiscal",
    "Código da venda": "Código da venda",
  },
  en: {
    "Emitir documento": "Issue document",
    "Documento enviado para emissão.": "Document submitted for issuance.",
    "Emitir documento fiscal": "Issue fiscal document",
    "Selecione uma venda concluída. A NF-e exige cliente com CPF/CNPJ e endereço fiscal completos.": "Select a completed sale. NF-e requires a customer with complete tax ID and fiscal address.",
    "Enviar para emissão": "Submit for issuance",
    "Emissão fiscal": "Fiscal issuance",
    "Código da venda": "Sale ID",
  },
  es: {
    "Emitir documento": "Emitir documento",
    "Documento enviado para emissão.": "Documento enviado para emisión.",
    "Emitir documento fiscal": "Emitir documento fiscal",
    "Selecione uma venda concluída. A NF-e exige cliente com CPF/CNPJ e endereço fiscal completos.": "Seleccione una venta completada. La NF-e exige un cliente con documento y domicilio fiscal completos.",
    "Enviar para emissão": "Enviar para emisión",
    "Emissão fiscal": "Emisión fiscal",
    "Código da venda": "Código de venta",
  },
  "zh-CN": {
    "Emitir documento": "开具单据",
    "Documento enviado para emissão.": "单据已提交开具。",
    "Emitir documento fiscal": "开具税务单据",
    "Selecione uma venda concluída. A NF-e exige cliente com CPF/CNPJ e endereço fiscal completos.": "请选择已完成的销售。NF-e 要求客户税号及税务地址完整。",
    "Enviar para emissão": "提交开具",
    "Emissão fiscal": "税务开票",
    "Código da venda": "销售编号",
  },
};
